<h1 mat-dialog-title *ngIf="!data?.item.username">{{'admin.users.addNew' | translate}}</h1>
<h1 mat-dialog-title *ngIf="data?.item.username">{{'admin.users.edit' | translate}}</h1>

<div>
    <form [formGroup]="form">
        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.users.username" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput  formControlName="username">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('username').errors?.required && (form.get('username').touched || (form.get('username').dirty)))">
            {{"common.validation.userSuperAdmin.userNameRequired" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.users.fullName" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput formControlName="fullName">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('fullName').errors?.required && (form.get('fullName').touched || (form.get('fullName').dirty)))">
            {{"common.validation.userSuperAdmin.fullNameRequired" | translate}}
        </span>

        <mat-form-field color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.users.role" | translate}}<span class="span-label-required"></span></mat-label>
            <mat-select formControlName="role">
              <mat-option [value]="UserRole.ADMIN">{{"admin.users.roles.admin" | translate}}</mat-option>
              <mat-option [value]="UserRole.USER">{{"admin.users.roles.user" | translate}}</mat-option>
            </mat-select>
          </mat-form-field>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.users.password" | translate}}<span class="span-label-required"></span></mat-label>
            <input type="password" matInput formControlName="password">
        </mat-form-field>
        <span style="color: red;" *ngIf="!data?.item.username && ((form.get('password').errors?.required && (form.get('password').touched || (form.get('password').dirty))))">
            {{"common.validation.userAdmin.passwordRequired" | translate}}
        </span>
        <span style="color: red;" *ngIf="(form.get('password').errors?.password && form.get('password').value && form.get('password').value !== '')">
            {{"common.validation.password" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.users.confirmPassword" | translate}}<span class="span-label-required"></span></mat-label>
            <input type="password" matInput formControlName="confirmPassword">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('confirmPassword').errors?.confirmPassword)">
            {{"common.validation.confirmPassword" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.users.customerName" | translate}}<span class="span-label-required"></span></mat-label>
            <mat-select formControlName="customerName">
                <mat-option *ngFor="let customerName of customerNames" [value]="customerName">{{customerName}}</mat-option>
            </mat-select>
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('customerName').errors?.required && (form.get('customerName').touched || (form.get('customerName').dirty)))">
            {{"common.validation.userSuperAdmin.customerNameRequired" | translate}}
        </span>

    </form>

    <div class="d-flex" style="margin-top: 20px;">
        <button mat-flat-button color="primary" (click)="save()" class="action-button">{{'common.buttons.save' | translate}}</button>
        <button mat-flat-button color="primary" (click)="discard()" class="action-button">{{'common.buttons.cancel' | translate}}</button>
    </div>
</div>
